/**
 * Оргструктура: дерево компании, отделы, ответственные, замещения.
 *
 * Все ручки, кроме regionResponsible, доступны только владельцу (admin);
 * regionResponsible открыт менеджерам — форма задачи показывает,
 * кому уйдёт согласование, до создания задачи.
 */
import { api } from './client'

export const orgApi = {
  structure: () => api.get('/admin/structure'),

  setRegionManager: (regionId, managerId) =>
    api.patch(`/admin/regions/${regionId}/manager`, { manager_id: managerId }),

  regionResponsible: (regionId) => api.get(`/regions/${regionId}/responsible`),

  createDepartment: (data) => api.post('/admin/departments', data),
  updateDepartment: (id, data) => api.patch(`/admin/departments/${id}`, data),
  removeDepartment: (id) => api.delete(`/admin/departments/${id}`),
  addDepartmentMember: (id, userId) =>
    api.post(`/admin/departments/${id}/members`, { user_id: userId }),
  removeDepartmentMember: (id, userId) =>
    api.delete(`/admin/departments/${id}/members/${userId}`),

  substitutions: () => api.get('/admin/substitutions'),
  createSubstitution: (data) => api.post('/admin/substitutions', data),
  revokeSubstitution: (id) => api.post(`/admin/substitutions/${id}/revoke`),
}
